<template>
  <div class="reference-property-change">
    <label>{{ property.label || $tc(property.key) }}</label>
    <ChoiceComponent
      v-model="factor"
      @input="delta = delta"
      :values="[
        { value: 1, label: '+' },
        { value: -1, label: '-' },
      ]"
    />
    <InputComponent v-model="delta" required v-bind="valueBindings" />
    <ButtonComponent
      class="reference-property-change__add"
      :icon="['fal', 'times']"
      type="button"
      @click="$emit('remove')"
    />
  </div>
</template>

<script>
import { InputComponent } from 'vue-elder-input'
import { ButtonComponent } from 'vue-elder-button'
import { ChoiceComponent } from 'vue-elder-choice'

export default {
  name: 'ReferencePropertyChange',
  props: {
    value: Object,
    property: Object,
  },
  data() {
    return {
      factor: 1,
    }
  },
  computed: {
    delta: {
      get() {
        return Math.abs(this.value.delta)
      },
      set(val) {
        this.$emit('input', { key: this.value.key, delta: val * this.factor })
      },
    },
    valueBindings() {
      let binding = {
        align: 'right',
        min: 0,
        suffix: this.property.suffix || '',
      }

      // Set Type
      switch (this.property.unit) {
        case 'Int':
          binding.mask = { mask: Number, unmask: true, scale: 0 }
          break
        case 'SquareMetre':
        case 'Metre':
        case 'Float':
          binding.mask = { mask: Number, unmask: true, scale: 2 }
          break
        case 'Currency':
          binding.mask = { mask: Number, thousandsSeparator: ' ', unmask: true, scale: 2 }
          break
      }

      return binding
    },
  },
  created() {
    if (this.value.delta < 0) this.factor = -1
  },
  components: {
    InputComponent,
    ButtonComponent,
    ChoiceComponent,
  },
}
</script>

<style lang="scss">
.reference-property-change {
  display: grid;
  grid-template-columns: auto 1fr auto;

  gap: 0.5rem 1em;

  & > label {
    font-weight: bold;
    grid-column: 1 / -1;
  }

  .elder-button {
    align-self: center;

    &__icon {
      padding: 0.2em 0.7em !important;
    }
  }

  .elder-choices {
    display: flex;
    align-items: center;
    border: 3px solid var(--border-color);
    background-color: var(--border-color);
    border-radius: 20px;
    overflow: clip;
    margin: 0;

    align-self: center;

    font-size: 1.2em;
    font-weight: bold;

    &__item {
      background-color: transparent;

      border-radius: 50%;

      display: flex;
      justify-content: center;
      align-items: center;

      $size: 30px;
      width: $size;
      height: $size;
    }

    &__item--active {
      background-color: white;
      box-shadow: 0 2px 10px -3px rgba(black, 0.5);
      color: black;
    }

    &__item-label {
      padding: 0;
    }

    button {
      border: none;
      margin: 0;
    }
  }
}
</style>
